import { combineReducers, createStore,compose,applyMiddleware } from 'redux';
import { createBrowserHistory } from 'history'
 
import { connectRouter,routerMiddleware } from 'connected-react-router'
 
 
export const history = createBrowserHistory({ basename: '/stockideas/customscreener' })


// actions.js
export const activateGeod = geod => ({
  type: 'ACTIVATE_GEOD',
  geod,
});

export const activateDatadic = datadic => ({
  type: 'ACTIVATE_DATADIC',
  datadic,
});

export const activateDatadicbackup = datadicbackup => ({
  type: 'ACTIVATE_DATADICBACKUP',
  datadicbackup,
});

export const activateStocks = stocks => ({
  type: 'ACTIVATE_STOCKS',
  stocks,
});
export const activateFiname = finame => ({
  type: 'ACTIVATE_FINAME',
  finame,
});
export const activatePath = apppath => ({
  type: 'ACTIVATE_PATH',
  apppath,
});

export const activateUid = auid => ({
  type: 'ACTIVATE_UID',
  auid,
});


export const activateRecord = record => ({
  type: 'ACTIVATE_RECORD',
  record,
});

export const activateRecordtb = recordtb => ({
  type: 'ACTIVATE_RECORDTB',
  recordtb,
});

export const activateScreen = screen => ({
  type: 'ACTIVATE_SCREEN',
  screen,
});

export const activateLoadid = loadid => ({
  type: 'ACTIVATE_LOADID',
  loadid,
});

export const closeGeod = () => ({
  type: 'CLOSE_GEOD',
});
 

export const activateTablehead = tablehead => ({
  type: 'ACTIVATE_TABLEHEAD',
  tablehead,
});

export const activateChange = change => ({
  type: 'ACTIVATE_CHANGE',
  change,
});
export const activateGoing= going => ({
  type: 'ACTIVATE_GOING',
  going,
});


export const activateShowfilter= showfilter => ({
  type: 'ACTIVATE_SHOWFILTER',
  showfilter,
});


export const activateSaveFilter= savefilter => ({
  type: 'ACTIVATE_SAVEFILTER',
  savefilter,
});

export const activatePageswitch= pageswitch => ({
  type: 'ACTIVATE_PAGESWITCH',
  pageswitch,
});

export const activateSavedes= savedes => ({
  type: 'ACTIVATE_SAVEDES',
  savedes,
});
export const activateAfters= afters => ({
  type: 'ACTIVATE_AFTERS',
  afters,
});

export const activateScreenList= screenlist => ({
  type: 'ACTIVATE_SCREENLIST',
  screenlist,
});

export const activateUnivid= univid => ({
  type: 'ACTIVATE_UNIVID',
  univid,
});

export const activateUnivname= univname => ({
  type: 'ACTIVATE_UNIVNAME',
  univname,
});

export const activateUnivtype= univtype => ({
  type: 'ACTIVATE_UNIVTYPE',
  univtype,
});

// reducers.js
export const univtype = (state = 0, action) => {
  switch (action.type) {
    case 'ACTIVATE_UNIVTYPE':
      return action.univtype;
    default:
      return state;
  }
};

export const univname = (state = 0, action) => {
  switch (action.type) {
    case 'ACTIVATE_UNIVNAME':
      return action.univname;
    default:
      return state;
  }
};

export const univid = (state = 0, action) => {
  switch (action.type) {
    case 'ACTIVATE_UNIVID':
      return action.univid;
    default:
      return state;
  }
};


export const screenlist = (state = [], action) => {
  switch (action.type) {
    case 'ACTIVATE_SCREENLIST':
      return action.screenlist;
    default:
      return state;
  }
};

 

export const afters = (state = {va1:'',va2:''}, action) => {
  switch (action.type) {
    case 'ACTIVATE_AFTERS':
      return action.afters;
    default:
      return state;
  }
};
export const savedes = (state = {name:'',des:''}, action) => {
  switch (action.type) {
    case 'ACTIVATE_SAVEDES':
      return action.savedes;
    default:
      return state;
  }
};



export const pageswitch = (state = [], action) => {
  switch (action.type) {
    case 'ACTIVATE_PAGESWITCH':
      return action.pageswitch;
    default:
      return state;
  }
};


export const savefilter = (state = [], action) => {
  switch (action.type) {
    case 'ACTIVATE_SAVEFILTER':
      return action.savefilter;
    default:
      return state;
  }
};
export const showfilter = (state = '', action) => {
  switch (action.type) {
    case 'ACTIVATE_SHOWFILTER':
      return action.showfilter;
    default:
      return state;
  }
};


export const going = (state = '', action) => {
  switch (action.type) {
    case 'ACTIVATE_GOING':
      return action.going;
    default:
      return state;
  }
};
export const change = (state = '', action) => {
  switch (action.type) {
    case 'ACTIVATE_CHANGE':
      return action.change;
    default:
      return state;
  }
};


export const tablehead = (state = {}, action) => {
  switch (action.type) {
    case 'ACTIVATE_TABLEHEAD':
      return action.tablehead;
    default:
      return state;
  }
};



export const geod = (state = {}, action) => {
  switch (action.type) {
    case 'ACTIVATE_GEOD':
      return action.geod;
    case 'CLOSE_GEOD':
      return {};
    default:
      return state;
  }
};


export const datadic = (state = {}, action) => {
  switch (action.type) {
    case 'ACTIVATE_DATADIC':
      return action.datadic;
    default:
      return state;
  }
};


export const datadicbackup = (state = {}, action) => {
  switch (action.type) {
    case 'ACTIVATE_DATADICBACKUP':
      return action.datadicbackup;
    default:
      return state;
  }
};

export const stocks = (state = 0, action) => {
  switch (action.type) {
    case 'ACTIVATE_STOCKS':
      return action.stocks;
    default:
      return state;
  }
};
export const finame = (state = '', action) => {
  switch (action.type) {
    case 'ACTIVATE_FINAME':
      return action.finame;
    default:
      return state;
  }
};
export const loadid = (state = '', action) => {
  switch (action.type) {
    case 'ACTIVATE_LOADID':
      return action.loadid;
    default:
      return state;
  }
};

export const apppath = (state = '', action) => {
  switch (action.type) {
    case 'ACTIVATE_PATH':
      return action.apppath;
    default:
      return state;
  }
};
export const auid = (state = '', action) => {
  switch (action.type) {
    case 'ACTIVATE_UID':
      return action.auid;
    default:
      return state;
  }
};

export const record = (state = '', action) => {
  switch (action.type) {
    case 'ACTIVATE_RECORD':
      return action.record;
    default:
      return state;
  }
};

export const recordtb = (state = '', action) => {
  switch (action.type) {
    case 'ACTIVATE_RECORDTB':
      return action.recordtb;
    default:
      return state;
  }
};

export const screen = (state = '', action) => {
  switch (action.type) {
    case 'ACTIVATE_SCREEN':
      return action.screen;
    default:
      return state;
  }
};




/* export const reducers = combineReducers({
  geod,datadic,apppath,stocks,record,auid,tablehead,datadicbackup,finame,screen,loadid,change,going
});
 */

const createRootReducer = (history) => combineReducers({
  router: connectRouter(history),
  geod,datadic,apppath,stocks,record,recordtb,auid,tablehead,datadicbackup,finame,screen,loadid,change,going,showfilter,savefilter,pageswitch,
  savedes,afters,screenlist,univid,univname,univtype,
})
 


// store.js


export   function configureStore(preloadedState) {
  const store = createStore(
    createRootReducer(history), // root reducer with router state
    preloadedState,
    compose(
      applyMiddleware(
        routerMiddleware(history), // for dispatching history actions
        // ... other middlewares ...
      ),
    ),
  )

  return store
}

export const store = configureStore();
/* export function configureStore(initialState = {}) {
  const store = createStore(reducers, initialState);
  return store;
}

export const store = configureStore(); */
